/*
 * @Author: HANG ZHANG
 * @Date: 2020-06-04 20:08:56
 * @Description:
 * @LastEditors: HANG ZHANG
 * @LastEditTime: 2020-06-04 20:08:57
 * @FilePath: /vision-h5/src/modules/icon/index.js
 */

// 引入组件
import IconComponent from './Icon.vue';
const Icon = {
	// install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
	install: function (Vue) {
		Vue.component('Icon', IconComponent);
	},
};
// 导出
export default Icon;



// WEBPACK FOOTER //
// ./src/modules/icon/index.js